/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorConversationsReviewRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.conversations.review',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorConversationsReviewRoute);
